import { render, staticRenderFns } from "./results-board-pending-user.vue?vue&type=template&id=6630942c&scoped=true&"
import script from "./results-board-pending-user.vue?vue&type=script&lang=ts&"
export * from "./results-board-pending-user.vue?vue&type=script&lang=ts&"
import style0 from "./results-board-pending-user.vue?vue&type=style&index=0&id=6630942c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630942c",
  null
  
)

export default component.exports